module.exports = "<span class=\"gw-accordion-chevron fa fa-chevron-right\" ng-class=\"{'gw-chevron-is-open': isOpen}\"></span>"


/*****************
 ** WEBPACK FOOTER
 ** ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/accordion/directives/templates/accordion-chevron.html
 ** module id = 650
 ** module chunks = 0
 **/